// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"8af46669","177":"a97103a1","233":"8ab4a293","241":"eff1915b","377":"b414386e","378":"708116d4","397":"d1b0615b","455":"94d684d9","530":"ae1ae3e1","765":"9ffdc080","770":"8ad648d9"}[chunkId] + ".chunk.js";
};